export const SITE = {
  name: "Sicilia Traslochi",
  tagline: "Movimentiamo il vostro futuro con cura",
  phone: "327 465 8675",
  phoneTel: "+393274658675",
  whatsapp: "393274658675",
  email: "info@siciliatraslochi.com",
  address: "Via Colajanni 230, Caltanissetta",
  site: "siciliatraslochi.com",
  hours: "Lun – Sab · 08:00 – 20:00",
  facebook: "https://www.facebook.com/profile.php?id=61587845017171",
  logoUrl:
    "https://customer-assets.emergentagent.com/wingman/19948741-6e04-4179-9f17-40c9ab60aafe/attachments/ad8b7a0ca5564446906c36da51a1aef0_Progetto%20senza%20titolo.png",
};

// Real photos provided by the company — DO NOT swap with stock / AI placeholders
export const PHOTOS = {
  team:
    "https://customer-assets.emergentagent.com/wingman/19948741-6e04-4179-9f17-40c9ab60aafe/attachments/0c0b711ad93741ce976b99ca782e7e0b_542e611b-41fa-4b0a-8eeb-37b7a6608d1a.jpg",
  truck:
    "https://customer-assets.emergentagent.com/wingman/19948741-6e04-4179-9f17-40c9ab60aafe/attachments/9a64e01f8bbf4d26a227a0130d84181b_5b0133a2-4391-4deb-9e31-cca39f2b26c7.jpg",
  mover:
    "https://customer-assets.emergentagent.com/wingman/19948741-6e04-4179-9f17-40c9ab60aafe/attachments/2abfa98aa3ea495380e82d5f7240ee0b_Gemini_Generated_Image_v2a808v2a808v2a8.png",
  office:
    "https://customer-assets.emergentagent.com/wingman/19948741-6e04-4179-9f17-40c9ab60aafe/attachments/c3780f297bc44701b61cfb48185d5996_Gemini_Generated_Image_w0abhlw0abhlw0ab.png",
  home:
    "https://customer-assets.emergentagent.com/wingman/19948741-6e04-4179-9f17-40c9ab60aafe/attachments/10deb73456184c989943aadd9515ea12_cleaned_image3.png",
  ladder:
    "https://customer-assets.emergentagent.com/wingman/19948741-6e04-4179-9f17-40c9ab60aafe/attachments/0af39a332d2d4361b93b33462b3c2c77_cleaned_image2.png",
  warehouse:
    "https://customer-assets.emergentagent.com/wingman/19948741-6e04-4179-9f17-40c9ab60aafe/attachments/7ead6a99cd7b43de96d8cec3e9859bf3_cleaned_image1.jpg",
};

export const SERVICES = [
  {
    key: "casa",
    label: "Traslochi Casa",
    title: "Traslochi Casa",
    desc:
      "Smontaggio, imballo, trasporto e rimontaggio. La nostra squadra Sicilia Traslochi tratta i vostri ricordi con la stessa cura di un membro della famiglia.",
    points: ["Squadra dedicata Sicilia Traslochi", "Coperte e protezioni premium", "Rimontaggio incluso"],
    img: PHOTOS.home,
  },
  {
    key: "uffici",
    label: "Traslochi Uffici",
    title: "Traslochi Uffici",
    desc:
      "Spostiamo aziende, studi e attività con un piano operativo che azzera i tempi di fermo e protegge ogni postazione.",
    points: ["Pianificazione oraria", "Cablaggi e arredi tecnici", "Riallestimento chiavi in mano"],
    img: PHOTOS.office,
  },
  {
    key: "autoscale",
    label: "Noleggio Autoscale",
    title: "Noleggio Autoscale",
    desc:
      "Autoscale fino a 36 metri con operatore certificato. Per piani alti, mobili ingombranti, cantieri e palazzi storici.",
    points: ["Operatore qualificato", "Permessi inclusi", "Sicurezza certificata"],
    img: PHOTOS.ladder,
  },
  {
    key: "imballaggio",
    label: "Imballaggio",
    title: "Imballaggio Sicuro",
    desc:
      "Materiali professionali e tecniche dedicate per ogni oggetto: cristalleria, opere d'arte, elettronica e arredi di pregio. Ogni scatola etichettata e catalogata.",
    points: ["Materiali certificati", "Etichettatura intelligente", "Catalogazione fotografica"],
    img: PHOTOS.mover,
  },
  {
    key: "sgombero",
    label: "Sgombero Magazzini e Case",
    title: "Sgombero Magazzini & Case",
    desc:
      "Svuotiamo case, cantine, magazzini e capannoni con i nostri mezzi brandizzati Sicilia Traslochi. Smaltimento certificato, recupero di ciò che vale, pulizia finale inclusa.",
    points: ["Smaltimento a norma di legge", "Mezzi Sicilia Traslochi dedicati", "Sgombero completo in 24-48h"],
    img: PHOTOS.warehouse,
  },
  {
    key: "nord_italia",
    label: "Sicilia → Nord Italia",
    title: "Sicilia → Nord Italia",
    desc:
      "Traslochi a lunga percorrenza dalla Sicilia a Milano, Torino, Bologna, Roma e tutto il Nord. Mezzi Sicilia Traslochi, tracciabilità totale, tempi certi.",
    points: ["Mezzi brandizzati Sicilia Traslochi", "Tratte settimanali tracciate", "Assicurazione completa porta-a-porta"],
    img: PHOTOS.truck,
  },
];

export const STATS = [
  { value: "18+", label: "Anni di esperienza" },
  { value: "4.200", label: "Traslochi completati" },
  { value: "100%", label: "Coperti da assicurazione" },
  { value: "4.9★", label: "Recensioni clienti" },
];

export const TESTIMONIALS = [
  {
    name: "Giuseppe La Rosa",
    role: "Caltanissetta",
    text:
      "Trasloco eseguito in tempi record, zero graffi, zero stress. Hanno trattato i mobili di mia nonna come fossero loro. Insuperabili.",
  },
  {
    name: "Avv. Maria Cammarata",
    role: "Studio Legale, Enna",
    text:
      "Hanno spostato l'intero studio in un weekend. Il lunedì eravamo operativi al 100%. Professionisti veri.",
  },
  {
    name: "Salvatore Inglima",
    role: "Gela",
    text:
      "Autoscala perfetta per il quinto piano. Squadra puntuale, educata e attenta a ogni dettaglio. Strafelice del servizio.",
  },
  {
    name: "Famiglia Vella",
    role: "Trasloco Caltanissetta → Milano",
    text:
      "Da Caltanissetta a Milano: tracciabilità totale e consegna nei tempi promessi. Non un graffio. Sembra impossibile, e invece è successo davvero.",
  },
  {
    name: "Rosalia Di Maria",
    role: "Caltanissetta",
    text:
      "Imballaggio incredibile: ogni piatto e ogni quadro sono arrivati intatti. Ho percepito la differenza di un servizio premium.",
  },
  {
    name: "Domenico Pulci",
    role: "Sgombero magazzino, San Cataldo",
    text:
      "Magazzino svuotato in due giorni. Hanno recuperato quello che si poteva recuperare e smaltito il resto a norma. Onestissimi.",
  },
];

export const FAQ = [
  {
    q: "Quanto costa un trasloco a Caltanissetta o in Sicilia?",
    a: "Ogni trasloco è un progetto unico. Dopo un sopralluogo gratuito (anche in videochiamata) riceverete un preventivo scritto, chiaro, senza sorprese. Trasparenza totale.",
  },
  {
    q: "Fate traslochi dalla Sicilia al Nord Italia?",
    a: "Sì, è una delle nostre specialità. Operiamo tratte settimanali verso Milano, Torino, Bologna, Verona, Roma e tutto il Centro-Nord. Mezzi dedicati, tracciamento e assicurazione completa porta-a-porta.",
  },
  {
    q: "Effettuate sgomberi di case e magazzini?",
    a: "Sì. Sgombriamo abitazioni, cantine, soffitte, magazzini e capannoni. Recuperiamo ciò che vale, smaltiamo il resto a norma di legge, lasciamo gli ambienti puliti e pronti.",
  },
  {
    q: "Il mio trasloco è assicurato?",
    a: "Sì, al 100%. Ogni servizio include una copertura assicurativa completa contro ogni imprevisto durante il ritiro, il trasporto e la consegna. Nessuna eccezione.",
  },
  {
    q: "In quanto tempo posso avere il preventivo?",
    a: "Vi richiamiamo entro 60 minuti negli orari lavorativi. Il preventivo dettagliato arriva entro 24 ore dal sopralluogo.",
  },
  {
    q: "Smontate e rimontate voi i mobili?",
    a: "Sì. Smontaggio, imballaggio, trasporto, rimontaggio e posizionamento al millimetro: pensiamo a tutto noi.",
  },
];

export const ROUTES = [
  { from: "Caltanissetta", to: "Milano", km: "1.450 km", days: "48-72 h" },
  { from: "Palermo", to: "Torino", km: "1.520 km", days: "48-72 h" },
  { from: "Catania", to: "Bologna", km: "1.350 km", days: "48-72 h" },
  { from: "Agrigento", to: "Verona", km: "1.480 km", days: "48-72 h" },
  { from: "Enna", to: "Roma", km: "950 km", days: "24-48 h" },
  { from: "Sicilia", to: "Tutto il Nord", km: "Door-to-door", days: "Su misura" },
];
